"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccomodationIcon = AccomodationIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function AccomodationIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.45455 11.9333C8.96364 11.9333 10.1818 10.772 10.1818 9.33333C10.1818 7.89467 8.96364 6.73333 7.45455 6.73333C5.94545 6.73333 4.72727 7.89467 4.72727 9.33333C4.72727 10.772 5.94545 11.9333 7.45455 11.9333ZM18.3636 6.73333H12.0909C11.5386 6.73333 11.0909 7.18105 11.0909 7.73333V12.8H3.81818V5.90909C3.81818 5.40701 3.41117 5 2.90909 5C2.40701 5 2 5.40701 2 5.90909V17.0909C2 17.593 2.40701 18 2.90909 18C3.41117 18 3.81818 17.593 3.81818 17.0909V15.4H20.1818V17.0909C20.1818 17.593 20.5888 18 21.0909 18C21.593 18 22 17.593 22 17.0909V10.2C22 8.28467 20.3727 6.73333 18.3636 6.73333Z",
    fill: "currentColor"
  }));
}